import React, { useState,useEffect } from "react";
import {
  Button,
  Container
} from "reactstrap";
import OtpInput from '../OtpInput/IndexOtpInput';
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import { otpSend, otpResend, otpVerify, register, checkExit, addEvaluation } from '../../actions'
import { adminAction } from "actions/adminAction";
import { updateAgendaByCounsellor } from "actions/adminAction";
import { updateAgendaBySupervisor } from "actions/adminAction";


// core components
function NoteBySupervisor({
  token,
  item,
  
}) {


  
  useEffect(() => {
    if (item) {
      setMessage(item.supervisor_note);
    }
  }, [token]);
  const [message, setMessage] = useState('');

  

  

  

  

  return (
    <Container>
      <div>
        <Formik
          initialValues={item}
         
        >
          {({ errors, touched, handleSubmit, handleReset, setFieldValue }) => (
            <Form onSubmit={handleSubmit} onReset={handleReset}>
              <div className="form-group">
                <label htmlFor="firstName" >
                  Note
                </label>
                <textarea class="form-control" id="message" rows="10"
                    
                     name="message"
                     value={message}
                     
                    >
                </textarea>
              </div>
             
             
           
            </Form>
          )}
        </Formik>
      </div>
    </Container>
  );
}

export default NoteBySupervisor;
